import dayjs from "dayjs";
import apis from "@/api";
import {exportSignForPdf} from "@/api/modules/signFor";

export default function download() {
    const handleDownload = (row) => {
        console.log("row.srcId===", row.srcId);
        const params = {
            fileName: row.srcName,
            uploadTime: dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss'),
            size: row.srcFileLength,
            fileId: row.srcId || row.id
        }
        apis.download(params).then(res => {
            console.log("res===", res)
            download(res, params.fileName)
        })
    }

    const batchDownload = (srcObjs) => {
        let ps = [];
        srcObjs.forEach(val => {
            ps.push(new Promise((resolve, reject) => {
                apis.download({fileId: val.id}).then(res => {
                    console.log("res===", res)
                    resolve(download(res, val.name))
                })
            }));
        });
        return Promise.all(ps).then(() => {
            console.log("all")
        }).catch((error) => {
            console.log("catch")
            console.log(error)
        })
    }

    const singleDownload = (fileId, fileName) => {
        console.log("fileId", fileId)
        const params = {
            fileId: fileId
        }
        return apis.download(params).then(res => {
            console.log("res===", res)
            download(res, fileName)
            return Promise.resolve()
        }).catch(() => Promise.reject())

    }

    // 下载素材关联业务模板
    const downloadAssetProductModel = () => {
        apis.downloadAssProdModel().then((res) => {
            console.log(res, "res")
            download(res, "素材关联业务模板.xls")
        })
    }

    // 导出广告检测
    const exportAdvertPictureMonitor = (fileId, fileName) => {
        console.log("fileId", fileId)
        const params = {
            id: fileId
        }
        return apis.exportAdvertPictureMonitor(params).then(res => {
            console.log("res===", res)
            download(res, fileName)
            return Promise.resolve()
        }).catch(() => Promise.reject())
    }
    // 导出广告检测PDF
    const exportAdvertPictureMonitorPdf = (fileId, fileName) => {
        console.log("fileId", fileId)
        const params = {
            id: fileId
        }
        return apis.exportAdvertPictureMonitorPdf(params).then(res => {
            console.log("res===", res)
            download(res, fileName)
            return Promise.resolve()
        }).catch(() => Promise.reject())
    }
    // 导出广告比对
    const exportAdvertPictureCompare = (fileId, fileName) => {
        console.log("fileId", fileId)
        const params = {
            id: fileId
        }
        return apis.exportAdvertPictureCompare(params).then(res => {
            console.log("res===", res)
            download(res, fileName)
            return Promise.resolve()
        }).catch(() => Promise.reject())
    }
    // 导出广告比对Pdf
    const exportAdvertPictureComparePdf = (fileId, fileName) => {
        console.log("fileId", fileId)
        const params = {
            id: fileId
        }
        return apis.exportAdvertPictureComparePdf(params).then(res => {
            console.log("res===", res)
            download(res, fileName)
            return Promise.resolve()
        }).catch(() => Promise.reject())
    }

    // 导出合同清单-word
    const exportContractWord = (id, fileName) => {
        console.log("id", id)
        const params = {
            id: id
        }
        return apis.exportContractWord(params).then(res => {
            console.log("res===", res)
            download(res, fileName)
            return Promise.resolve()
        }).catch(() => Promise.reject())
    }

    // 导出合同清单-pdf
    const exportContractPdf = (id, fileName) => {
        console.log("id", id)
        return apis.exportContractPdf({id: id}).then(res => {
            console.log("res===", res)
            download(res, fileName)
            return Promise.resolve()
        }).catch(() => Promise.reject())
    }
    // 导出合同清单明细-pdf
    const exportSettlementExcel = (id, fileName) => {
        console.log("id", id)
        console.log("ifileNamed", fileName)
        return apis.downloadSettlementList({contractId: id}).then(res => {
            console.log("res===", res)
            download(res, fileName)
            return Promise.resolve()
        }).catch(() => Promise.reject())
    }

    // 导出监测结果报告-pdf
    const downMonitorResultPdf = (id, fileName) => {
        return apis.downMonitorResultPdf({advertLaunchId: id}).then(res => {
            console.log("res===", res)
            // download(res, fileName)
            return Promise.resolve(res)
        }).catch(() => Promise.reject())
    }
    // 导出签收单-pdf
    const downSignForPdf = (id, fileName) => {
        return apis.exportSignForPdf({infoId: id}).then(res => {
            console.log("res===", res)
            download(res, fileName)
            return Promise.resolve(res)
        }).catch(() => Promise.reject())
    }

    const download = (data, fileName) => {
        console.log("data:", data);
        console.log("fileName:", data);
        if (!data) {
            return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(new Blob([data]), fileName)
        } else {
            let url = window.URL.createObjectURL(new Blob([data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link) // 下载完成移除元素
            window.URL.revokeObjectURL(url) // 释放掉blob对象
            console.log("download");
        }
    }
    return {
        exportSettlementExcel,
        handleDownload,
        batchDownload,
        singleDownload,
        downloadAssetProductModel,
        exportAdvertPictureMonitor,
        exportAdvertPictureMonitorPdf,
        exportAdvertPictureComparePdf,
        exportAdvertPictureCompare,
        exportContractPdf,
        downSignForPdf,
        exportContractWord,
        downMonitorResultPdf
    }
}
